export enum OrderRiderActionEnum {
	AddedToQueue = 0,
	Offer = 1,
	Skip = 2,
	Accept = 3,
	Decline = 4,
	Cancel = 5,
	ArrivedToPickup = 6,
	PickedUp = 7,
	ArrivedToDrop = 8,
	Completed = 9,
	ForceAssigned = 10,
	TimedOut = 11,
	Ignored = 12,
	DroppedOutOfSearch = 13,
	SkipWithoutAffect = 14,
	AblyAcknowledged = 15
}

